const _BATTLECHECK = 5000;
const _STARTBATTLE = 1000;
const _FLIP = 1000;

Vue.component('teamBattleArena', {
  template: templates.teamBattleArena,
  data() {
    return {
      model: {
        id: null,
        type: null,
        cards1: [],
        cards2: [],
        streamer1: null,
        streamer2: null,
        // cards3: [],
        // cards4: [],
        // cards5: [],
        // cards6: [],
        // cards7: [],
        // cards8: [],
        team1winner: [],
        team2winner: [],
        index1: 0,
        index2: 0,
        finalBattle: false,
        team1: [],
        team2: [],
        // user1: {
        //   twitchId: null,
        //   twitchDisplayName: null,
        //   twitchProfileImage: null,
        // },
        // user2: {
        //   twitchId: null,
        //   twitchDisplayName: null,
        //   twitchProfileImage: null,
        // },
        // user3: {
        //   twitchId: null,
        //   twitchDisplayName: null,
        //   twitchProfileImage: null,
        // },
        // user4: {
        //   twitchId: null,
        //   twitchDisplayName: null,
        //   twitchProfileImage: null,
        // },
        // user5: {
        //   twitchId: null,
        //   twitchDisplayName: null,
        //   twitchProfileImage: null,
        // },
        // user6: {
        //   twitchId: null,
        //   twitchDisplayName: null,
        //   twitchProfileImage: null,
        // },
        // user7: {
        //   twitchId: null,
        //   twitchDisplayName: null,
        //   twitchProfileImage: null,
        // },
        // user8: {
        //   twitchId: null,
        //   twitchDisplayName: null,
        //   twitchProfileImage: null,
        // },
        battleLoaded: false,
        abilities: [],
        settings: {},
        stolenCard: null,
        show: {
          profile_intro: false,
          winner: false,
          cards: false,
          stolenCard: false,
          users: false,
          move: false,
          logs: false,
        },
        audio: {},
        logs: [],
        events: [],
      },
    };
  },
  mounted() {
    const c = this;

    c.setupSounds();
    c.getSettings();
    c.getAbilities();
  },
  methods: {
    stop() {
      const c = this;
      c.playerDefeated(1);
    },
    setupSounds() {
      const c = this;

      c.model.audio.hit = new Audio('../audio/hit.mp3');
      c.model.audio.flip = new Audio('../audio/card-flip.mp3');
      c.model.audio.move = new Audio('../audio/whoosh-02.mp3');
      c.model.audio.win = new Audio('../audio/award-01.mp3');
    },
    getSettings() {
      const c = this;

      let data = {};

      settingsService
        .get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.key}`] = d;
          }
          c.model.settings = data;

          setTimeout(function () {
            c.getSettings();
          }, 30000);
        })
        .catch(function (error) {});
    },
    stupidLog(message) {
      $('.stupid-log').prepend(`<p>${message}</p>`);
    },
    getAbilities() {
      const c = this;
      let data = {};

      abilityService
        .get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }

          c.model.abilities = data;
          c.getBattles();
        })
        .catch(function (error) {
          getAbilities();
        });
    },
    getStatus() {
      const c = this;

      teamBattleService
        .getStatus(c.model.id)
        .then(function (response) {
          if (response.data.deleted || response.data.queue) {
            // window.location.reload();
          }

          setTimeout(function () {
            c.getStatus();
          }, 4000);
        })
        .catch(function (error) {});
    },
    getBattles() {
      const c = this;

      //Prevent calling api while a battle is happening
      if (c.model.battleLoaded) {
        return;
      }

      //TODO refactor this at some point
      if (c.model.settings.autobattle && c.model.settings.autobattle.value) {

        //Get active battle
        teamBattleService
          .getAuto()
          .then(function (response) {
            let data = response.data[0];

            if (c.model.id != data.id) {
              c.model.battleLoaded = true;
              c.processBattle(data);
              c.getTwitchUsers();
            }
          })
          .catch(function (error) {
            setTimeout(function () {
              c.getBattles();
            }, _BATTLECHECK);
          });
      } else {
        //Get active battle
        teamBattleService
          .getActive()
          .then(function (response) {
            console.log(response)
            let data = response.data[0];
            // console.log(data.id);
            if (c.model.id != data.id) {
              c.model.battleLoaded = true;
              c.processBattle(data);
        
              // c.getTwitchUsers();
            }
        
          })
          .catch(function (error) {
            setTimeout(function () {
              c.getBattles();
            }, _BATTLECHECK);
          });
      }
    },
    //Add cards to model and get twitch info
    processBattle(data) {
      const c = this;
      c.model.type = data.type
      c.model.id = data.id;
      c.model.streamer1 = data.streamerChallenge;
      c.model.streamer2 = data.streamerAccept;

      c.getStatus();


      const team1 = data.team1.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateA - dateB;
      });

      const team2 = data.team2.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateA - dateB;
      });

      c.model.team1 = team1;
      c.model.team2 = team2;

      if(data.type == '2v2'){
        let cards1 = playingCards.getCardsStats(
          data.user1Cards,
          c.model.abilities
        );
        let cards2 = playingCards.getCardsStats(
          data.user2Cards,
          c.model.abilities
        );

        let cards5 = playingCards.getCardsStats(
          data.user5Cards,
          c.model.abilities
        );
        let cards6 = playingCards.getCardsStats(
          data.user6Cards,
          c.model.abilities
        );

        c.model.team1[0].cards.push(...cards1);
        c.model.team1[1].cards.push(...cards2);
  
        c.model.team2[0].cards.push(...cards5)
        c.model.team2[1].cards.push(...cards6);
      }
      else if(data.type=='3v3'){
        let cards1 = playingCards.getCardsStats(
          data.user1Cards,
          c.model.abilities
        );
        let cards2 = playingCards.getCardsStats(
          data.user2Cards,
          c.model.abilities
        );
        let cards3 = playingCards.getCardsStats(
          data.user3Cards,
          c.model.abilities
        );
  
        let cards5 = playingCards.getCardsStats(
          data.user5Cards,
          c.model.abilities
        );
        let cards6 = playingCards.getCardsStats(
          data.user6Cards,
          c.model.abilities
        );
        let cards7 = playingCards.getCardsStats(
          data.user7Cards,
          c.model.abilities
        );
        c.model.cards1 = cards3;
        c.model.cards2 = cards2;

        c.model.team1[0].cards.push(...cards1);
        c.model.team1[1].cards.push(...cards2);
        c.model.team1[2].cards.push(...cards3);
  
        c.model.team2[0].cards.push(...cards5)
        c.model.team2[1].cards.push(...cards6);
        c.model.team2[2].cards.push(...cards7);

      }

      else if(data.type=='4v4'){

        let cards1 = playingCards.getCardsStats(
          data.user1Cards,
          c.model.abilities
        );
        let cards2 = playingCards.getCardsStats(
          data.user2Cards,
          c.model.abilities
        );
        let cards3 = playingCards.getCardsStats(
          data.user3Cards,
          c.model.abilities
        );
        let cards4 = playingCards.getCardsStats(
          data.user4Cards,
          c.model.abilities
        );
  
        let cards5 = playingCards.getCardsStats(
          data.user5Cards,
          c.model.abilities
        );
        let cards6 = playingCards.getCardsStats(
          data.user6Cards,
          c.model.abilities
        );
        let cards7 = playingCards.getCardsStats(
          data.user7Cards,
          c.model.abilities
        );
        let cards8 = playingCards.getCardsStats(
          data.user8Cards,
          c.model.abilities
        );

        // c.model.cards1.push(...cards1);
        // c.model.cards1.push(...cards2);
        // c.model.cards2.push(...cards3);
        // c.model.cards2.push(...cards4);
  
        c.model.team1[0].cards.push(...cards1);
        c.model.team1[1].cards.push(...cards2);
        c.model.team1[2].cards.push(...cards3);
        c.model.team1[3].cards.push(...cards4);
  
        c.model.team2[0].cards.push(...cards5)
        c.model.team2[1].cards.push(...cards6);
        c.model.team2[2].cards.push(...cards7);
        c.model.team2[3].cards.push(...cards8);
        
      }
      setTimeout(function () {
            c.startBattle();
          }, _STARTBATTLE);
      },
    //Start battle by flipping first cards and applying the initial abilities
    startBattle: function () {

      const c = this;
      //c.model.show.battle = true;
      c.showStats();
      setTimeout(function (){
        c.model.show.profile_intro = true;
        setTimeout(function () {
          c.model.show.profile_intro = false;
          c.model.show.users = true;
  
          setTimeout(function () {
            c.model.show.move = true;
  
            setTimeout(function () {
              c.model.show.cards = true;
  
              setTimeout(function () {
                if(c.model.team1.length === 2 &&  c.model.team2.length === 2){
                  c.flip(c.model.team1[0].cards[0], 0);
                  c.flip(c.model.team1[1].cards[0], 0);
                  c.flip(c.model.team2[0].cards[0], 0);
                  c.flip(c.model.team2[1].cards[0], 0);
                }
                else if(c.model.team1.length === 3 &&  c.model.team2.length === 3){
                  c.flip(c.model.team1[0].cards[0], 0);
                  c.flip(c.model.team1[1].cards[0], 0);
                  c.flip(c.model.team1[2].cards[0], 0);
                  c.flip(c.model.team2[0].cards[0], 0);
                  c.flip(c.model.team2[1].cards[0], 0);
                  c.flip(c.model.team2[2].cards[0], 0);
                }
                else{
                  c.flip(c.model.team1[0].cards[0], 0);
                  c.flip(c.model.team1[1].cards[0], 0);
                  c.flip(c.model.team1[2].cards[0], 0);
                  c.flip(c.model.team1[3].cards[0], 0);
                  c.flip(c.model.team2[0].cards[0], 0);
                  c.flip(c.model.team2[1].cards[0], 0);
                  c.flip(c.model.team2[2].cards[0], 0);
                  c.flip(c.model.team2[3].cards[0], 0);
                }
            
                c.model.audio.flip.play();
  
                //TODO seems like this isn't supposed to be here
                // c.applyTurnAbiltiy(c.model.cards1[0], c.model.cards2, c.model.cards1);
                // c.app  lyTurnAbiltiy(c.model.cards2[0], c.model.cards2, c.model.cards1);
                setTimeout(function () {  
                  //trigger initial abilities
                  if(c.model.team1.length === 2 &&  c.model.team2.length === 2){
                    c.teamInitialAbilities(c.model.team1[0].cards, c.model.team2[0].cards,c.model.team1[0].index, c.model.team2[0].index );
                    c.teamInitialAbilities(c.model.team1[1].cards, c.model.team2[1].cards, c.model.team1[1].index, c.model.team2[1].index);
                  }
                  else if (c.model.team1.length === 3 &&  c.model.team2.length === 3){
                     c.teamInitialAbilities(c.model.team1[0].cards, c.model.team2[0].cards, c.model.team1[0].index, c.model.team2[0].index, 0 );
                      c.teamInitialAbilities(c.model.team1[1].cards, c.model.team2[1].cards, c.model.team1[1].index, c.model.team2[1].index, 1);
                      c.teamInitialAbilities(c.model.team1[2].cards, c.model.team2[2].cards,c.model.team1[2].index, c.model.team2[2].index, 2);
                  }
                  else{
                    c.teamInitialAbilities(c.model.team1[0].cards, c.model.team2[0].cards,c.model.team1[0].index, c.model.team2[0].index );
                    c.teamInitialAbilities(c.model.team1[1].cards, c.model.team2[1].cards, c.model.team1[1].index, c.model.team2[1].index);
                    c.teamInitialAbilities(c.model.team1[2].cards, c.model.team2[2].cards,c.model.team1[2].index, c.model.team2[2].index );
                    c.teamInitialAbilities(c.model.team1[3].cards, c.model.team2[3].cards,c.model.team1[3].index, c.model.team2[3].index );
                
                  }
                  c.startRound();
                }, 1500);
              }, 1000);
            }, 1000);
          }, 1500);
        }, 5000);
      },1000)
     
    },
    teamInitialAbilities(cards1, cards2 , index1, index2, indexOf){

      const c = this;

      
      c.applyInitialAbilities(
        cards1,
        cards2,
        index1,
        index2,
        indexOf
      );
      c.applyInitialAbilities(
        cards2,
        cards1,
        index2,
        index1,
        indexOf
      );
      c.applyTurnAbiltiy(
        cards1[0],
        cards1,
        cards2,
        index1,
        index2,
        indexOf
      );
      c.applyTurnAbiltiy(
        cards2[0],
        cards2,
        cards1,
        index2,
        index1,
        indexOf
      );
    },
    //Apply abilities for abilities that fire at the beginning of the battle
    applyInitialAbilities: function (cards1, cards2, index1, index2, indexOf) {

      const c = this;
   
      let index = indexOf;
      for (let card of cards1) {
        try {
          if (
            card.abilityKey &&
            typeof abilities.initial[`${card.abilityKey}`] === 'function'
          ) {
            abilities.initial[`${card.abilityKey}`](
              cards1,
              cards2,
              index1,
              index2,
              c.model.events
            );
            c.logEvent(`${card.name} used ${card.ability}!`);
          }
        } catch (err) {
          c.logError(`${card.ability} through an error`);
        }
      }

      // c.startRound(cards1,cards2,index1, index2, 1, index);
    },
    startRound(first,second, third, fourth) {

      const c = this;
      if(c.model.team1.length === 2 &&  c.model.team2.length === 2){

          if(c.model.team1winner.length > 1 || c.model.team2winner.length > 1 ){
            console.log(c.model.team2winner.length)
            if(c.model.team2winner.length === 2){
              c.teamDefeated(1)
            }
            if(c.model.team1winner.length === 2){
              c.teamDefeated(1)
            }
            setTimeout(function () {
                c.model.finalBattle = true;

                setTimeout(function () {
                  c.flip(c.model.cards1[0], 0);
                  c.flip(c.model.cards2[0], 0);
                  c.model.audio.flip.play();
                setTimeout(function () {
                  c.handleTeamWinner(Math.random());
                }, 1000);
                },1000)
            }, 2000);

          }
          else{

              if(c.model.team1[0].cards.length > c.model.team1[0].index && c.model.team2[0].cards.length > c.model.team2[0].index){
                c.handleTeamAttack(0, Math.random() );
            }
              if(c.model.team1[1].cards.length > c.model.team1[1].index && c.model.team2[1].cards.length > c.model.team2[1].index){
                c.handleTeamAttack(1, Math.random() );
            }
        
        }
      }
      if(c.model.team1.length === 3 &&  c.model.team2.length === 3){
          console.log('hey')
          if(c.model.team1winner.length > 1 || c.model.team2winner.length > 1 ){
            console.log('heyyyy')

            if(c.model.team2winner.length === 3){
              c.teamDefeated(1)
            }
            if(c.model.team1winner.length === 3){
              c.teamDefeated(1)
            }
            setTimeout(function () {
                c.model.finalBattle = true;

                setTimeout(function () {
                  c.flip(c.model.cards1[0], 0);
                  c.flip(c.model.cards2[0], 0);
                  c.model.audio.flip.play();
                setTimeout(function () {
                  c.handleTeamWinner(Math.random());
                }, 1000);
                },1000)
            }, 2000);

          }
          else{

              if(c.model.team1[0].cards.length > c.model.team1[0].index && c.model.team2[0].cards.length > c.model.team2[0].index){
                c.handleTeamAttack(0, Math.random() );
            }
              if(c.model.team1[1].cards.length > c.model.team1[1].index && c.model.team2[1].cards.length > c.model.team2[1].index){
                c.handleTeamAttack(1, Math.random() );
            }
              if(c.model.team1[2].cards.length > c.model.team1[2].index && c.model.team2[2].cards.length > c.model.team2[2].index){
              c.handleTeamAttack(2, Math.random() );
            }
        
        }
      }
      if(c.model.team1.length === 4 &&  c.model.team2.length === 4){

          if(c.model.team1winner.length > 1 || c.model.team2winner.length > 1 ){

            if(c.model.team2winner.length === 4){
              c.teamDefeated(1)
            }
            if(c.model.team1winner.length === 4){
              c.teamDefeated(2)
            }
            setTimeout(function () {
                c.model.finalBattle = true;

                setTimeout(function () {
                  c.flip(c.model.cards1[0], 0);
                  c.flip(c.model.cards2[0], 0);
                  c.model.audio.flip.play();
                setTimeout(function () {
                  c.handleTeamWinner(Math.random());
                }, 1000);
                },1000)
            }, 2000);

          }
          else{

              if(c.model.team1[0].cards.length > c.model.team1[0].index && c.model.team2[0].cards.length > c.model.team2[0].index){
                c.handleTeamAttack(0, Math.random() );
            }
              if(c.model.team1[1].cards.length > c.model.team1[1].index && c.model.team2[1].cards.length > c.model.team2[1].index){
                c.handleTeamAttack(1, Math.random() );
            }
              if(c.model.team1[2].cards.length > c.model.team1[2].index && c.model.team2[2].cards.length > c.model.team2[2].index){
              c.handleTeamAttack(2, Math.random() );
            }
              if(c.model.team1[3].cards.length > c.model.team1[3].index && c.model.team2[3].cards.length > c.model.team2[3].index){
              c.handleTeamAttack(3, Math.random() );
            }
        
        }
      }
      
    },
    handleTeamAttack(index, first){
      const c= this;

        if (c.model.team1[index].cards.length > c.model.team1[index].index && c.model.team2[index].cards.length > c.model.team2[index].index) {
          
        let totalMoveCount = 0;
        let moveCount1 = c.getAttachCount(c.model.team1[index].cards[c.model.team1[index].index]);
        let moveCount2 = c.getAttachCount(c.model.team2[index].cards[c.model.team2[index].index]);
        totalMoveCount += moveCount1;
        totalMoveCount += moveCount2;


        if( first < 0.5){
          for (let i = 0; i < moveCount1; i++) {
            setTimeout(function () {
              if (
                c.attemptAttack(
                  c.model.team1[index].cards[c.model.team1[index].index],
                  c.model.team2[index].cards[c.model.team2[index].index],
                  c.model.team1[index].cards,
                  c.model.team2[index].cards,
                  c.model.team1[index].index,
                  c.model.team2[index].index,
                  1
                )
              ) {
                c.model.team2[index].index += 1;
                c.flip(c.model.team2[index].cards[c.model.team2[index].index]);
                setTimeout(function () {
                  c.applyTurnAbiltiy(
                    c.model.team2[index].cards[c.model.team2[index].index],
                    c.model.team2[index].cards,
                    c.model.team1[index].cards,
                    c.model.team2[index].index,
                    c.model.team1[index].index,
                    2
                  );
                }, _FLIP);
              }
            }, 1000 * i);
          }
          setTimeout(function () {
            for (let i = 0; i < moveCount2; i++) {
              setTimeout(function () {
                if (
                  c.attemptAttack(
                    c.model.team2[index].cards[c.model.team2[index].index],
                    c.model.team1[index].cards[c.model.team1[index].index],
                    c.model.team2[index].cards,
                    c.model.team1[index].cards,
                    c.model.team2[index].index,
                    c.model.team1[index].index,
                    2
                  )
                ) {
                  c.model.team1[index].index += 1;
                  c.flip(c.model.team1[index].cards[c.model.team1[index].index]);
                  setTimeout(function () {
                    c.applyTurnAbiltiy(
                      c.model.team1[index].cards[c.model.team1[index].index],
                      c.model.team1[index].cards,
                      c.model.team2[index].cards,
                      c.model.team1[index].index,
                      c.model.team2[index].index
                    );
                  }, _FLIP);
                }
              }, 1000 * i);
            }
          }, 1250 * moveCount1);
        }
        else {
          for (let i = 0; i < moveCount2; i++) {

            setTimeout(function () {
              if (
                c.attemptAttack(
                  c.model.team2[index].cards[c.model.team2[index].index],
                  c.model.team1[index].cards[c.model.team1[index].index],
                  c.model.team2[index].cards,
                  c.model.team1[index].cards,
                  c.model.team2[index].index,
                  c.model.team1[index].index,
                  2
                )
              ) {
                c.model.team1[index].index += 1;
                c.flip(c.model.team1[index].cards[c.model.team1[index].index]);
                setTimeout(function () {
                  c.applyTurnAbiltiy(
                    c.model.team1[index].cards[c.model.team1[index].index],
                    c.model.team1[index].cards,
                    c.model.team2[index].cards,
                    c.model.team1[index].index,
                    c.model.team2[index].index
                  );
                }, _FLIP);
              }
            }, 1000 * i);
          }

          setTimeout(function () {
            for (let i = 0; i < moveCount1; i++) {
              setTimeout(function () {
                if (
                  c.attemptAttack(
                    c.model.team1[index].cards[c.model.team1[index].index],
                    c.model.team2[index].cards[c.model.team2[index].index],
                    c.model.team1[index].cards,
                    c.model.team2[index].cards,
                    c.model.team1[index].index,
                    c.model.team2[index].index,
                    1
                  )
                ) {
                  c.model.team2[index].index += 1;
                  c.flip(c.model.team2[index].cards[c.model.team2[index].index]);
                  setTimeout(function () {
                    c.applyTurnAbiltiy(
                      c.model.team2[index].cards[c.model.team2[index].index],
                      c.model.team2[index].cards,
                      c.model.team1[index].cards,
                      c.model.team2[index].index,
                      c.model.team1[index].index,
                    );
                  }, _FLIP);
                }
              }, 1000 * i);
            }
          }, 1250 * moveCount2);
        }

        setTimeout(function () {
          c.handleTeamAttack(
            index,
            first
          );
        }, 2500 * (totalMoveCount - 1));

        return
      
      }
      else{
        console.log(c.model.team1[index].cards.length)
        console.log(c.model.team1[index].index)
          if (c.model.team1[index].index == c.model.team1[index].cards.length) {
            console.log('hehe')
            console.log(index)
              c.model.team2winner.unshift(c.model.team2[index])
                for(i = 0; i < c.model.team2[index].cards.length; i++){
                  const hp = c.model.team2[index].cards[i].hp;
                  if (hp > 0) {
                    c.model.cards2.unshift(c.model.team2[index].cards[i])
                }
                }
                // const validCards = c.model.team2[index].cards.filter(card => card.hp > 0);
                // // console.log(c.model.team2[index].cards[i].hp)
                // validCards.forEach((_, i) => {
                //   c.model.cards1.unshift(c.model.team2[index].cards[i]);
                //   console.log(c.model.team2[index].cards)
                // });
           
          }
          
          if (c.model.team2[index].index == c.model.team2[index].cards.length) {
            console.log('hehehe')
            console.log(index)
              c.model.team1winner.unshift(c.model.team1[index])

              for(i = 0; i < c.model.team1[index].cards.length; i++){
                const hp = c.model.team1[index].cards[i].hp;
                if (hp > 0) {
                    c.model.cards1.unshift(c.model.team1[index].cards[i])
                    
                }
              }
                // const validCards = c.model.team1[index].cards.filter(card => card.hp < 0);
                // // console.log(c.model.team2[index].cards[i].hp)
                // validCards.forEach((_, i) => {
                //   c.model.cards1.unshift(c.model.team1[index].cards[i]);
                //   console.log(c.model.team1[index].cards)
                // });
          
          }

         
      }

      if(c.model.team1.length == c.model.team1winner.concat(c.model.team2winner).length){
        
        let $removeContainer= $(`#first_round`);

        for(i = 0; i < c.model.team1.length; i++){

          if (c.model.team1[i].index == 4) {
            let $userDefeated = $(`#${c.model.team1[i].user[0].twitchId}`);
            $userDefeated.addClass('fade-out');
      
            setTimeout(function () {
              $userDefeated.remove();
            }, 1000);
            
          }

          if (c.model.team2[i].index == 4) {
              let $userDefeated = $(`#${c.model.team2[i].user[0].twitchId}`);
              $userDefeated.addClass('fade-out');
              setTimeout(function () {
                $userDefeated.remove();
              }, 1000);
          }

        }
        $removeContainer.addClass('fade-out');
        setTimeout(function () {
          $removeContainer.remove();
        }, 1000);
        
        // if(c.model.team2winner.length > c.model.team1winner.length){
        //   for (let i = 0; i < c.model.team2winner.length; i++) {
        //     c.model.cards1.push(...c.model.team1winner[i].cards)
        //     c.model.cards2.push(...c.model.team2winner[i].cards)
        //   }

        // }
        // else{
        //   for (let i = 0; i < c.model.team1winner.length; i++) {
        //     c.model.cards1.push(...c.model.team1winner[i].cards)
        //     c.model.cards2.push(...c.model.team2winner[i].cards)
        //   }
        // }

        
        c.startRound()
      }
      console.log(c.model)

    },
    handleTeamWinner(first){
      const c= this;
      if (
        c.model.cards1.length > c.model.index1 &&
        c.model.cards2.length > c.model.index2
      ) {
        let totalMoveCount = 0;
        let moveCount1 = c.getAttachCount(c.model.cards1[c.model.index1]);
        let moveCount2 = c.getAttachCount(c.model.cards2[c.model.index2]);
        totalMoveCount += moveCount1;
        totalMoveCount += moveCount2;

        // Randomly choose which card attacks first
        // Card 1 goes first
        if (first < 0.5) {
          for (let i = 0; i < moveCount1; i++) {
            setTimeout(function () {
              if (
                c.attemptAttack(
                  c.model.cards1[c.model.index1],
                  c.model.cards2[c.model.index2],
                  c.model.cards1,
                  c.model.cards2,
                  c.model.index1,
                  c.model.index2
                )
              ) {
                c.model.index2 += 1;
                c.flip(c.model.cards2[c.model.index2]);
                setTimeout(function () {
                  c.applyTurnAbiltiy(
                    c.model.cards2[c.model.index2],
                    c.model.cards2,
                    c.model.cards1,
                    c.model.index2,
                    c.model.index1
                  );
                }, _FLIP);
              }
            }, 1000 * i);
          }

          setTimeout(function () {
            for (let i = 0; i < moveCount2; i++) {
              setTimeout(function () {
                if (
                  c.attemptAttack(
                    c.model.cards2[c.model.index2],
                    c.model.cards1[c.model.index1],
                    c.model.cards2,
                    c.model.cards1,
                    c.model.index2,
                    c.model.index1
                  )
                ) {
                  c.model.index1 += 1;
                  c.flip(c.model.cards1[c.model.index1]);
                  setTimeout(function () {
                    c.applyTurnAbiltiy(
                      c.model.cards1[c.model.index1],
                      c.model.cards1,
                      c.model.cards2,
                      c.model.index1,
                      c.model.index2
                    );
                  }, _FLIP);
                }
              }, 1000 * i);
            }
          }, 1250 * moveCount1);

          // Card 2 goes first
        } else {
          for (let i = 0; i < moveCount2; i++) {

            setTimeout(function () {
              if (
                c.attemptAttack(
                  c.model.cards2[c.model.index2],
                  c.model.cards1[c.model.index1],
                  c.model.cards2,
                  c.model.cards1,
                  c.model.index2,
                  c.model.index1
                )
              ) {
                c.model.index1 += 1;
                c.flip(c.model.cards1[c.model.index1]);
                setTimeout(function () {
                  c.applyTurnAbiltiy(
                    c.model.cards1[c.model.index1],
                    c.model.cards1,
                    c.model.cards2,
                    c.model.index1,
                    c.model.index2
                  );
                }, _FLIP);
              }
            }, 1000 * i);
          }

          setTimeout(function () {
            for (let i = 0; i < moveCount1; i++) {
              setTimeout(function () {
                if (
                  c.attemptAttack(
                    c.model.cards1[c.model.index1],
                    c.model.cards2[c.model.index2],
                    c.model.cards1,
                    c.model.cards2,
                    c.model.index1,
                    c.model.index2
                  )
                ) {
                  c.model.index2 += 1;
                  c.flip(c.model.cards2[c.model.index2]);
                  setTimeout(function () {
                    c.applyTurnAbiltiy(
                      c.model.cards2[c.model.index2],
                      c.model.cards2,
                      c.model.cards1,
                      c.model.index2,
                      c.model.index1
                    );
                  }, _FLIP);
                }
              }, 1000 * i);
            }
          }, 1250 * moveCount2);
        }

        setTimeout(function () {
          c.handleTeamWinner(
            c.model.cards1,
            c.model.cards2,
            c.model.index1,
            c.model.index2,
            first
          );
        }, 2500 * (totalMoveCount - 1));

        return;
      } 

      if (c.model.index2 == c.model.cards2.length) {
        
        console.log('team1');
        let $removeContainer= $(`#final_round`);
        setTimeout(function () {
          $removeContainer.remove();
        }, 1000);

        c.teamDefeated(1);
      } else {
        console.log('team1');
        let $removeContainer= $(`#final_round`);
        setTimeout(function () {
          $removeContainer.remove();
        }, 1000);
        c.teamDefeated(2);
      }
     
     
    },
    applyTurnAbiltiy(card, cards1, cards2, index1, index2, indexOf) {
      const c = this;
      try {
        if (
          card &&
          card.abilityKey &&
          typeof abilities.turn[`${card.abilityKey}`] === 'function'
        ) {
          abilities.turn[`${card.abilityKey}`](
            cards1,
            cards2,
            index1,
            index2,
            c.model.events
          );
          c.logEvent(`${card.name} used ${card.ability}!`);
        }
      } catch (err) {
        c.logError(`${card.ability} through an error`);
      }
    },
    attemptAttack(card1, card2, cards1, cards2, index1, index2, team) {
      const c = this; 

      if (!card1 || !card2) {
        return false;
      }

      if (card1.turnSkips > 0) {
        card1.turnSkips -= 1;
        c.saveEvent({ cardId: card.id, skipped: true });
        c.logEvent(`${card1.name}'s turn was skipped`);
        return false;
      }

      c.model.audio.move.play();

      try {
        if (typeof abilities.move[`${card1.abilityKey}`] === 'function') {
          abilities.move[`${card1.abilityKey}`](
            cards1,
            cards2,
            index1,
            index2,
            c.model.events
          );
          c.logEvent(`${card1.name} used ${card1.ability}!`);
        }
      } catch (err) {
        c.logError(`${card1.ability} through an error`);
      }

      c.cardAttack(card1);
      let cardHp = card2.hp;

      let attachNumber = Math.random() * 100;

      if (attachNumber < Number(card1.accuracy)) {
        //Get min damage of between 50 - 250;
        const randomDamage = Math.floor(Math.random() * 200) + 50;
        const initialDamage = Math.max(
          randomDamage,
          Number(card1.attack) - Number(card2.defence)
        );

        //Get a percent of the total damage to slightly randomize total damage
        let damageVariancePercent = Math.floor(Math.random() * (100 - 75) + 75);
        //Caculate the chance for a critical 30% chance
        const criticalChance = Math.floor(Math.random() * 10) + 1;
        let critical = false;

        if (criticalChance < card1.criticalChance) {
          critical = true;
          //Critical damage varies from 101 - 120%
          damageVariancePercent =
            100 + Math.floor(Math.random() * (20 - 1) + 1);
        }

        //Get new damage ammount
        const variedDamage = Math.round(
          (damageVariancePercent / 100) * initialDamage
        );

        cardHp -= variedDamage;

        c.saveEvent({
          cardId: card1.id,
          damage: variedDamage,
          critical: critical,
        });
        c.damageTaken(
          card2,
          variedDamage,
          critical,
          cards1,
          cards2,
          index1,
          index2
        );
      } else {
        c.saveEvent({ cardId: card1.id, missed: true });
        c.logEvent(`${card1.name} missed it's attach`);
      }
      if (cardHp <= 0) {
        c.cardDefeated(card2,index1, index2);
        return true;
      }


      return false;
    },
    cardAttack(card) {
      let $card = $(`#${card.id}`).find('.playing-card-wrapper');
      $card.addClass('attack');

      setTimeout(function () {
        $card.removeClass('attack');
      }, 1200);
    },
    damageTaken(card, damage, critical, cards1, cards2, index1, index2) {
      const c = this;
      let $card = $(`#${card.id}`);


      let $hpLost = $(`<span class="hp-lost">-${damage}</span>`);
      $card.append($hpLost);
      $card.find('.playing-card-wrapper').addClass('-shakeX');

      if (critical) {
        $card.find('.playing-card-wrapper').addClass('-flash');
      }

      c.logEvent(`${card.name} took ${damage} damage`);

      setTimeout(function () {
        //So the visual hp on the card doesn't go below 0
        if (card.hp - damage < 0) {
          card.hp = 0;
        } else {
          card.hp -= damage;

          try {
            if (typeof abilities.damaged[`${card.abilityKey}`] === 'function') {
              abilities.damaged[`${card.abilityKey}`](
                cards2,
                cards1,
                index2,
                index1,
                damage,
                c.model.events
              );
              c.logEvent(`${card.name} used ${card.ability}!`);
            }
          } catch (err) {
            c.logError(`${card.ability} through an error`);
          }
        }


        c.model.audio.hit.play();

        $hpLost.addClass('show');
        $card.find('.playing-card-wrapper').removeClass('-shakeX -flash');
      }, 300);

      setTimeout(function () {
        $hpLost.addClass('remove');

        setTimeout(function () {
          $hpLost.remove();
        }, 3000);
      }, 1300);
    },
    cardDefeated(card, index1, index2) {
      let c = this;
      //setTimeout(function() {
      let $card = $(`#${card.id}`);
      $card.addClass('remove');

      setTimeout(function () {
        // console.log(c.model)
        $card.remove();
      }, 1000);
      //}, 1000);

      c.saveEvent({ cardId: card.id, defeated: true });
      c.logEvent(`${card.name} was defeated!`);
    },
    playerDefeated(player) {
      const c = this;

      c.logEvent(`Player ${player} was defeated!`);

      c.model.battleLoaded = false;
      c.model.show.cards = false;
      c.model.show.users = false;

      c.model.audio.win.play();

      const winnerTwitchId =
        player == 1 ? c.model.user2.twitchId : c.model.user1.twitchId;

      let data = {
        id: c.model.id,
        winnerTwitchId: winnerTwitchId,
        events: c.model.events,
      };

      setTimeout(function () {
        c.model.show.winner = false;

        if (c.model.settings.autobattle && c.model.settings.stealcards.value) {
          c.model.stolenCard = c.stealCard(
            player == 1 ? c.model.cards1 : c.model.cards2
          );
          data.stolenCardId = c.model.stolenCard.id;

          setTimeout(function () {
            c.showStats();
            c.model.show.stolenCard = true;
            c.flip(c.model.stolenCard);

            setTimeout(function () {
              c.model.show.stolenCard = false;
              setTimeout(function () {
                c.saveBattle(data);
              }, 500);
            }, 3500);
          }, 1500);
        } else {
          c.saveBattle(data);
        }
      }, 3500);
    },
    teamDefeated(player) {
      const c = this;

      c.logEvent(`Team ${player} was wins!`);

      c.model.battleLoaded = false;
      c.model.show.cards = false;
      c.model.show.users = false;
      c.model.show.logs = false;

      c.model.show.winner = true;
      const $user = $(`.col.user${player == 1 ? 1 : 2}`).clone();
      $('.winner div').html('').append($user);

      c.model.audio.win.play();

      const winnerTwitchId =
        player == 1 ? c.model.user2.twitchId : c.model.user1.twitchId;

      let data = {
        id: c.model.id,
        winnerTwitchId: winnerTwitchId,
        events: c.model.events,
      };

      setTimeout(function () {
        c.model.show.winner = false;

        if (c.model.settings.autobattle && c.model.settings.stealcards.value) {
          c.model.stolenCard = c.stealCard(
            player == 1 ? c.model.cards1 : c.model.cards2
          );
          data.stolenCardId = c.model.stolenCard.id;

          setTimeout(function () {
            c.showStats();
            c.model.show.stolenCard = true;
            c.flip(c.model.stolenCard);

            setTimeout(function () {
              c.model.show.stolenCard = false;
              setTimeout(function () {
                c.saveBattle(data);
              }, 500);
            }, 3500);
          }, 1500);
        } else {
          c.saveBattle(data);
        }
      }, 3500);
    },
    saveBattle(data) {
      const c = this;
      teamBattleService
        .save(data)
        .then(function (response) {
          setTimeout(function () {
            c.model.stolenCard = null;
            // window.location.reload();
          }, 8000);
        })
        .catch(function (error) {
          c.logEvent(error);
        });
    },
    showStats() {
      $('.info').removeClass('is-visible');
      $('.bottom').removeClass('is-hidden');
    },
    saveEvent(data) {
      const c = this;
      data.battleId = c.model.id;
      c.model.events.push(data);
    },
    logEvent(message) {
      const c = this;
      // console.log(message);
      c.model.show.logs = true;
      setTimeout(function () {
        c.model.logs.unshift(message);
        c.model.logs = c.model.logs.slice(0, 10);
      }, 300);
    },
    logError(message) {
      const c = this;
      logService
        .save({ message: message })
        .then(function (response) {})
        .catch(function (error) {});
    },
    stealCard(cards) {
      const index = Math.floor(Math.random() * cards.length);
      return cards[index];
    },
    getAttachCount(card) {
      const c = this;
      const maxSpeed = 6000;
      const cardSpeed = card.speed;

      if (cardSpeed == maxSpeed) {
        maxSpeed = maxSpeed * 1.2;
      }

      let chance = cardSpeed / maxSpeed / 3;
      chance = Math.round(chance * 100) / 100;

      if (Math.random() < chance) {
        return 2;
      }

      return 1;
    },
    flip(card, timeout = _FLIP) {
      const c = this;
      if (!card) return;
      setTimeout(function () {
        let id = card.id;
        c.$root.$emit(`flip${id}`, id);
        c.model.audio.flip.play();
      }, timeout);
    },
  },
});
